<template>
  <div class="centred-full-width">
    <h1 class="centred-full-width__headline">{{data.headlineText}}</h1>
    <rich-text class="centred-full-width__paragraph" :textData="data.introCopy" />
  </div>
</template>

<script>
import RichText from './RichText.vue';

export default {
  props: ['data'],
  components: { RichText },
};
</script>

<style scoped>
.centred-full-width {
  text-align: center;
  padding: 72px 24px;
}

.centred-full-width__headline {
  width: 100%;
  margin: 0;
  font-family: var(--headline-font);
  font-weight: normal;
  font-size: 72px;
  line-height: 1;
  color: var(--very-light);
}

.centred-full-width__paragraph {
  margin: 18px 0 0 0;
  font-family: var(--body-font);
  line-height: 1.5;
  color: var(--very-light);
}
</style>
